<template>
  <section class="video" name="video">
    <div class="container">
      <!--<a-typography-title :level="1">-->
      <!--  云原生及Serverless基础软件服务商-->
      <!--</a-typography-title>-->
      <!--<a-typography-paragraph>-->
      <!--    <span>集成本优化、高效运维、稳定性治理于一体的</span>-->
      <!--    <br v-if="$Store.Public().isGridMatch('<',$Enum.GridEnum.MD)" />-->
      <!--    <span>一站式平台</span>-->
      <!--</a-typography-paragraph>-->
      <div class="box_video" :class="{active:expand.active}">
        <video ref="video" :src="href.video"
               controls preload />
        <i class="video_play"
           @click="clickPlayVideo" />
      </div>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';

export default {
  name: 'home_video',
  components: {},
  data(): DataInterface {
    return {
      href: {
        video: 'https://gf-files-lf.oss-cn-beijing.aliyuncs.com/video/SchedulX-%E4%BA%91%E5%8E%9F%E7%94%9F%E5%9F%BA%E7%A1%80%E6%B2%BB%E7%90%86%E5%B9%B3%E5%8F%B0.mp4'
      },
      expand: {
        active: false
      }
    };
  },
  methods: {
    /**
     * 点击播放视频
     */
    clickPlayVideo() {
      this.expand.active = true;
      this.$refs.video && this.$refs.video.play();
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@imagePublic: '@{src_image}public/';
@image: '@{src_image}page/home/';

.video {
  overflow: hidden;
  position: relative;
  z-index: 0;
  padding: 0 @padding;
  background: @color_white;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    //padding: @space 0;
    margin: 0 auto;
    .borderBox();
  }
}

h1.ant-typography {
  margin: 0;
  .font(center, @title, @color_12, @title, true);
}

div.ant-typography {
  margin: @margin 0 0;
  .font(center, @text, @color_13, @text);
}

.box_video {
  overflow: hidden;
  position: relative;
  max-width: 850px;
  max-height: 470px;
  margin: @margin auto 0;
  border-radius: 5px;
  background-color: @color_black;
  
  &.active {
    &::before,
    &::after,
    .video_play {
      opacity: 0 !important;
      pointer-events: none !important;
    }
    
    video {
      opacity: 1;
    }
  }
  
  &::before,
  &::after,
  video,
  .video_play {
    .transition(opacity @time);
  }
  
  &::before,
  &::after {
    content: '';
    display: block;
    .position();
  }
  
  &::before {
    z-index: 1;
    .bg('@{image}video_bg.png');
    background-size: cover;
  }
  
  &::after {
    z-index: 2;
    background: fade(@color_black, 30);
  }
  
  video {
    display: block;
    position: relative;
    width: 100%;
    opacity: 0;
  }
  
  .video_play {
    display: block;
    .position();
    z-index: 3;
    margin: auto;
    .bg('@{imagePublic}video_play.png', 128px, 128px);
    background-position: center;
    opacity: 0.85;
    cursor: pointer;
    
    &:hover {
      opacity: 1;
    }
  }
}

@media screen and (max-width: -1px+@grid_md) {
  .video {
    .container {
      padding: @space_mo 0;
    }
  }
  
  h1.ant-typography {
    .font(center, @title, @color_12, @title_mo, true);
  }
  
  div.ant-typography {
    .font(center, @text_mo+@line_mo, @color_13, @text_mo);
  }
  
  .box_video {
    max-width: 315px;
    max-height: 175px;
    
    .video_play {
      background-size: 80px 80px !important;
    }
  }
}
</style>